/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PlatformApiResultOfIChingConsultationDto } from '../../models/platform-api-result-of-i-ching-consultation-dto';

export interface GetIchingConsultationsMineId$Params {
  id: string;
}

export function getIchingConsultationsMineId(http: HttpClient, rootUrl: string, params: GetIchingConsultationsMineId$Params, context?: HttpContext): Observable<StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>> {
  const rb = new RequestBuilder(rootUrl, getIchingConsultationsMineId.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlatformApiResultOfIChingConsultationDto>;
    })
  );
}

getIchingConsultationsMineId.PATH = '/api/iching/consultations/mine/{id}';
